export enum SupportTicketSeverity {
  urgent = 'urgent',
  high = 'high',
  normal = 'normal',
  low = 'low',
}
